import { P, FF } from "../../styles/tokens";

export function Heading({ children, size = 14 }) {
  return (
    <div style={{ fontSize: size, fontWeight: 800, color: P.text, fontFamily: FF, marginBottom: 16 }}>
      {children}
    </div>
  );
}

export function Label({ children, size = 11 }) {
  return (
    <div style={{ fontSize: size, fontWeight: 500, color: P.textXs, fontFamily: FF, letterSpacing: "0.06em", textTransform: "uppercase" }}>
      {children}
    </div>
  );
}

export function Amount({ children, size = 22, token }) {
  return (
    <div style={{ fontSize: size, fontWeight: 900, color: token ? token.text : P.text, fontFamily: FF, letterSpacing: "-0.5px", lineHeight: 1.1 }}>
      {children}
    </div>
  );
}

export function Divider({ my = 16 }) {
  return <div style={{ height: 1, background: P.border, margin: `${my}px 0` }} />;
}
